/* eslint-disable no-unused-vars */
import React from 'react'
import { Row, Switch } from 'antd'
import { useWindowSize } from 'src/app/hooks'
import { CustomCol, FormLabels } from 'src/components'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'

interface SaleOfferAllowCounterProps {
  value: boolean
  handleChange: (value: boolean) => void
  title: string
  subtitle: string
}

const SaleOfferBooleanFlag: React.FC<SaleOfferAllowCounterProps> = (props) => {
  const { isMobile } = useWindowSize()

  return <Row>
    <CustomCol xs={19}>
      <FormLabels
        title={props.title}
        subtitle={props.subtitle}
      />
    </CustomCol>
    <CustomCol xs={5}>
      <Switch
        className={isMobile && 'mt-2 ml-3'}
        checked={props.value}
        onChange={(value) => props.handleChange(value)}
        checkedChildren={<CheckOutlined />}
        unCheckedChildren={<CloseOutlined />}
      />
    </CustomCol>
  </Row>
}

export default SaleOfferBooleanFlag
